export default "__VITE_ASSET__MQ6QJigt__"